// import { setUrlPath } from '@/lib';
import { useStore } from "@/store";
import React from "react";
import Modal from "react-modal";
import Scrollbar from "react-scrollbars-custom";

Modal.setAppElement("#root");

type Props = {
  modalStatus: boolean;
  closeModal: () => void;
};

const ModalRule: React.FC<Props> = ({ modalStatus, closeModal }) => {
  const { getParam } = useStore();
  const afterOpenModal = () => {};

  const selfClose = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const modalElement = document.querySelector(".swing-in-top-fwd");
    if (modalElement) {
      modalElement.classList.add("swing-out-top-bck");
    }
    // setUrlPath('/')

    setTimeout(() => {
      closeModal();
    }, 300);
  };

  return (
    <Modal
      isOpen={modalStatus}
      onAfterOpen={afterOpenModal}
      onRequestClose={selfClose}
      contentLabel="Example Modal"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="swing-in-top-fwd modal-rule"
    >
      <div className="modal-description">
        <h2>Hướng dẫn</h2>
        <Scrollbar
          style={{ height: "26vw" }}
          className="modal-scrollbar"
          noScrollX={true}
        >
          <div className="rule">
            <div
              dangerouslySetInnerHTML={{ __html: `${getParam("rule")}` }}
            ></div>
          </div>
        </Scrollbar>
      </div>
      <a href="#" className="close" onClick={selfClose}></a>
    </Modal>
  );
};
export default ModalRule;
